<template>
<BootstrapDialog title="人脸比对详情" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row" style="border-bottom: 1px solid gray">
		        <div class="col-sm-5 col-sm-offset-1">
		            <div class="form-group">
		                <label class="col-sm-4 control-label" style="height: 200px;line-height: 200px;font-weight: bolder">准考证照片:</label>
		                <div class="col-sm-8">
		                    <img :src="query.xcpz"
		                         alt="" style="height: 200px;">
		                </div>
		            </div>
		        </div>
		        <div class="col-sm-5 ">
		            <div class="form-group">
		                <label class="col-sm-4 control-label" style="height: 200px;line-height: 200px;font-weight: bolder">考试照片:</label>
		                <div class="col-sm-8">
		                    <img :src="query.bizZypxKsrlbd.url"
		                         alt="" style="height: 200px;">
		                </div>
		            </div>
		        </div>
		    </div>
		    <div class="row" style="margin-top: 30px">
		        <label class="col-sm-4 control-label" style="font-weight: bolder">比对置信度:</label>
		        <p class="col-sm-2">{{query.bizZypxKsrlbd.bdzxd}}</p>
		        <p style="color:red">*范围[0~100]，比对置信度值越大，则判断为同一人几率越大</p>
		    </div>
		    <div class="row" style="margin-top: 30px">
		        <label class="col-sm-4 control-label" style="font-weight: bolder">创建时间:</label>
		        <p class="col-sm-4">{{query.bizZypxKsrlbd.jlsj}}</p>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 平时作业-比对
     */
    export default {
        name: "HomeworkPhotoCompare",
        components: {
		},
        data: function () {
            return {
                query: {
                    xcpz: '',
                    ksId: '',
                    id: '',
                    bizZypxKsrlbd: {
                        bdzxd: '',
                        jlsj: '',
                        sftg: '',
                        url: '',
                        xmId: '',
                     },
                }
            }
        },
        methods: {
			reset:function(){
				this.query = {
					xcpz: '',
					ksId: '',
					id: '',
					bizZypxKsrlbd: {
						bdzxd: '',
						jlsj: '',
						sftg: '',
						url: '',
						xmId: '',
					 },
				}
			},
			async open(params){
				this.query.xcpz = params.xcpz;
				this.query.ksId = params.ksId;
				this.query.id = params.id;
				let res =await this.$http.post('/htgl/biz/zypx/pszyjk/jkxq',this.query);
				if(res.data){
					this.query.bizZypxKsrlbd.url= res.data.bizZypxKsrlbd.url;
					this.query.bizZypxKsrlbd.bdzxd = res.data.bizZypxKsrlbd.bdzxd;
					this.query.bizZypxKsrlbd.jlsj = res.data.bizZypxKsrlbd.jlsj;
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			}
        }
    }
</script>
<style scoped>


</style>